var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.8789,
    y: 20,
    width: 42.5974,
    height: 42.5974,
    transform: "rotate(45 65.8789 20)",
    fill: "#0AC087",
    fillOpacity: 0.69
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1211,
    y: 20,
    width: 42.5974,
    height: 42.5974,
    transform: "rotate(45 34.1211 20)",
    fill: "#0AC087",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.2760c1c141991ae317d81a2ff9215671.svg";
export { ForwardRef as ReactComponent };